import React, { useCallback, useMemo } from "react";
import {
  Route,
  generatePath,
  useRouteMatch,
  useParams,
} from "react-router-dom";
import isEqual from "lodash/isEqual";
import { ProtectedRoute } from "../components/ProtectedRoute";
import { useMemoCompare } from "../hooks";
import { ModalRouteDefinition } from "./routes";

export const ModalRoutes: React.FC<{ modals?: ModalRouteDefinition[] }> = ({
  modals,
}) => {
  const match = useRouteMatch();
  const params = useParams();
  const memoModals = useMemoCompare(modals, isEqual);
  const fallbackUrl = useMemo(() => generatePath(match.path, params), [
    match.path,
    params,
  ]);
  const generateRoutePaths = useCallback(
    (extensions: string | string[]) =>
      Array.isArray(extensions)
        ? extensions.map((ext) => match.path + ext)
        : match.path + extensions,
    [match.path],
  );

  return useMemo(
    () =>
      memoModals ? (
        <>
          {memoModals.map(
            ({ extension, exact, component: Component, ...config }, i) => {
              const RouteComponent = config?.protected ? ProtectedRoute : Route;
              const path = generateRoutePaths(extension);

              return (
                <RouteComponent
                  key={i}
                  path={path}
                  exact={exact}
                  render={(props) => {
                    return <Component {...props} fallbackUrl={fallbackUrl} />;
                  }}
                />
              );
            },
          )}
        </>
      ) : null,
    [fallbackUrl, generateRoutePaths, memoModals],
  );
};
